<ef-process-detail [process]="process$ | async"></ef-process-detail>

<ef-vendor-presenter
[items]="VendorModel$ | async"
[selectedError]="selectedErrorWithStatus$ | async"
[vendors]="VendorModel$ | async"
[employeesSelectItem]="employeesSelectItem$ | async"
(SaveVendor)="onSaveVendor($event)"
(GetVendor)="onGetVendor($event)"
(ShowError)="ShowErrorSubject.next($event)"
></ef-vendor-presenter>
